/**
 * MediaContent - Expand/Collapse functionality for strategic section
 */
(function() {
    'use strict';

    // Only show collapse if content significantly exceeds the visible area
    const COLLAPSE_THRESHOLD = 220;

    function initMediaContent() {
        const strategicSection = document.querySelector('.media-content-strategic');
        const expandBtn = document.querySelector('[data-expand-btn]');
        const bodyContent = document.querySelector('.media-content-strategic-body');

        if (!strategicSection || !bodyContent) {
            return;
        }

        // Check if content is long enough to need collapsing
        const contentHeight = bodyContent.scrollHeight;
        const needsCollapse = contentHeight > COLLAPSE_THRESHOLD;

        if (!needsCollapse) {
            // Short content - always show expanded, hide button and gradient
            strategicSection.classList.add('expanded', 'no-collapse');
            if (expandBtn) {
                expandBtn.style.display = 'none';
            }
            return;
        }

        // Long content - enable collapse functionality
        if (!expandBtn) {
            return;
        }

        var expandText = expandBtn.getAttribute('data-expand-text') || 'Expand';
        var collapseText = expandBtn.getAttribute('data-collapse-text') || 'Collapse';

        expandBtn.addEventListener('click', function() {
            var isExpanded = strategicSection.classList.contains('expanded');

            if (isExpanded) {
                strategicSection.classList.remove('expanded');
                expandBtn.querySelector('span').textContent = expandText;
            } else {
                strategicSection.classList.add('expanded');
                expandBtn.querySelector('span').textContent = collapseText;
            }
        });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initMediaContent);
    } else {
        initMediaContent();
    }

    // Re-initialize on Neos backend content changes
    if (typeof document.addEventListener === 'function') {
        document.addEventListener('Neos.PageLoaded', initMediaContent);
    }
})();
